import { Box, Link, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import { ReactComponent as ExternalLinkSVG } from "../scenes/stack/environment/icons/action_icons/actions-external-link-currentColor.svg";
import CustomToolTip from "./CustomTooltip";

const TextWithExternalLink = ({
  text,
  linkText,
  href,
  tooltipText = "View in new tab",
  linkColor = null,
  ...props
}) => {
  const colors = useColors();
  return (
    <Typography
      variant="body2"
      style={{
        color: "inherit",
        display: "inline",
      }}
      {...props}
    >
      {text}{" "}
      <CustomToolTip title={tooltipText} placement="top">
        <Link
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color={linkColor || colors.primary_main}
          style={{
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <Box width="fit-content" display="flex" gap={0.5}>
            {linkText}
            <SvgToIcon
              IconLogo={ExternalLinkSVG}
              width={"16px"}
              style={{ color: linkColor || colors.primary_main }}
            />
          </Box>
        </Link>
      </CustomToolTip>
    </Typography>
  );
};

export default TextWithExternalLink;
